import { makeAutoObservable } from 'mobx';
import type { ValidationErrors } from 'final-form';
import type { ReactElement } from 'react';

export interface DrawerButtonInterface {
  label: () => JSX.Element;
  key: string | number;
  submitButton?: boolean;
  editButton?: boolean;
  onClick?: () => void;
  type?: 'default' | 'primary' | 'link' | 'text' | 'ghost' | 'dashed' | undefined;
  className?: string;
}

interface DrawerFormInterface {
  form: ((editMode: boolean) => JSX.Element | JSX.Element[]) | JSX.Element | JSX.Element[];
  formData: Record<string, unknown>;
  editMode?: boolean;
  submit?: (props: Record<string, unknown>) => void;
  buttons?: DrawerButtonInterface[];
  validate?: (values: unknown) => ValidationErrors | Promise<ValidationErrors> | undefined;
  withRequired?: boolean;
  title?: string | ReactElement | ReactElement[];
}

class DesignDrawerStore {
  form: DrawerFormInterface | null = null;

  info: JSX.Element | null = null;

  isShowInfo = false;

  doNotCleanInfoNextStage = false;

  errors: Record<string, boolean> = {};

  showInfo = (info?: ReactElement | null) => {
    if (info !== undefined) {
      if (this.doNotCleanInfoNextStage) {
        this.doNotCleanInfoNextStage = false;
      } else {
        this.info = info;
      }
    }
    this.isShowInfo = true;
  };

  hideInfo = () => {
    this.isShowInfo = false;
  };

  constructor() {
    makeAutoObservable(this);
  }

  setCustomForm = (form: DrawerFormInterface | null) => {
    this.form = form;
  };

  setErrors = (errors: Record<string, boolean>) => {
    this.errors = errors;
  };
}

export const designDrawerStore = new DesignDrawerStore();
